import { render, staticRenderFns } from "./BookingArchive.vue?vue&type=template&id=6f2661b9&"
import script from "./BookingArchive.vue?vue&type=script&lang=js&"
export * from "./BookingArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports